import React from 'react';

import {
  EAbilityActions,
  type EAbilitySubjects,
} from '@client/hooks/useAbilities';

import { EditableTags } from './EditableTags';

import type { MongoAbility } from '@casl/ability';

type TTagProps = {
  testId?: string | undefined;
  disabled: boolean;
  ableFor: {
    ability: MongoAbility;
    subject: string | keyof typeof EAbilitySubjects;
  };
  tags: string[];
  onUpdateTags?: (tags: string[]) => void;
};

export const TagsComponent: React.FC<TTagProps> = (props) => {
  const { testId, disabled, ableFor, tags = [], onUpdateTags } = props;

  const canDelete = ableFor.ability.can(
    EAbilityActions.DELETE,
    ableFor.subject,
  );
  const canUpdate = ableFor.ability.can(
    EAbilityActions.UPDATE,
    ableFor.subject,
  );
  const canCreate = ableFor.ability.can(
    EAbilityActions.CREATE,
    ableFor.subject,
  );

  return (
    <div data-testid={testId}>
      <EditableTags
        canDelete={canDelete}
        canUpdate={canUpdate}
        canCreate={canCreate}
        disabled={disabled}
        onChange={onUpdateTags}
        tags={tags}
      />
    </div>
  );
};
